<div class="ClaimMainContent">

  <!-- Apple iPhone-style Error Message -->
  <div class="ClaimErrorContainer" *ngIf="showError">
    <div class="ClaimErrorCard">
      <div class="ClaimErrorIconWrapper">
        <i class="material-icons ClaimErrorIcon" *ngIf="errorType === 'missing_params'">link_off</i>
        <i class="material-icons ClaimErrorIcon" *ngIf="errorType === 'partner_not_found'">person_off</i>
        <i class="material-icons ClaimErrorIcon" *ngIf="errorType === 'claim_not_found'">search_off</i>
      </div>
      <div class="ClaimErrorTitle" *ngIf="errorType === 'missing_params'">{{ 'ClaimErrorMissingParamsTitle' | translate }}</div>
      <div class="ClaimErrorTitle" *ngIf="errorType === 'partner_not_found'">{{ 'ClaimErrorPartnerNotFoundTitle' | translate }}</div>
      <div class="ClaimErrorTitle" *ngIf="errorType === 'claim_not_found'">{{ 'ClaimErrorClaimNotFoundTitle' | translate }}</div>
      <div class="ClaimErrorDescription" *ngIf="errorType === 'missing_params'">{{ 'ClaimErrorMissingParamsDescription' | translate }}</div>
      <div class="ClaimErrorDescription" *ngIf="errorType === 'partner_not_found'">{{ 'ClaimErrorPartnerNotFoundDescription' | translate }}</div>
      <div class="ClaimErrorDescription" *ngIf="errorType === 'claim_not_found'">{{ 'ClaimErrorClaimNotFoundDescription' | translate }}</div>
    </div>
  </div>

  <!-- Page Title (above tab switcher) -->
  <div class="ClaimPageTitleWrapper" *ngIf="showPageTitle && !showError">
    <h1 class="ClaimPageTitle">{{ 'ClaimMenuForPartner' | translate }} {{ pageTitle }}</h1>
  </div>

  <!-- Tab Switcher (only show when no error) -->
  <div class="GridModeTabsWrapper" *ngIf="!showError">
    <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': !showNewClaimTab && !viewMode}" (click)="showMyClaimsTab()">
      <i class="material-icons">list</i>
      <span>{{ 'MyClaimsTitle' | translate }}</span>
    </div>
    <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': showNewClaimTab}" (click)="showNewClaimTabClick()">
      <i class="material-icons">add_circle</i>
      <span>{{ 'NewClaimTitle' | translate }}</span>
    </div>
  </div>

  <!-- MY CLAIMS TAB -->
  <div *ngIf="!showNewClaimTab && !viewMode && !showError">
    <!-- Claims List -->
    <div class="ClaimsListContainer" *ngIf="!loadingClaims && claims.length > 0">
      <div class="ClaimCard" *ngFor="let claim of claims" (click)="openClaimDetails(claim)">
        <div class="ClaimCardHeader">
          <div class="ClaimCardTitle">
            <i class="material-icons">report_problem</i>
            <span>{{ claim.Title }}</span>
          </div>
          <div class="ClaimCardReference">{{ claim.Reference }}</div>
        </div>
        <div class="ClaimCardBody">
          <div class="ClaimCardRow">
            <span class="ClaimCardLabel">{{ 'Date' | translate }}:</span>
            <span class="ClaimCardValue">{{ claim.EventRegisterUI }}</span>
          </div>
          <div class="ClaimCardRow">
            <span class="ClaimCardLabel">{{ 'Status' | translate }}:</span>
            <span class="ClaimCardValue">{{ claim.Status?.Name }}</span>
          </div>
          <div class="ClaimCardRow" *ngIf="claim.GeneralType">
            <span class="ClaimCardLabel">{{ 'ClaimType' | translate }}:</span>
            <span class="ClaimCardValue">{{ claim.GeneralType?.Name }}</span>
          </div>
          <div class="ClaimCardRow" *ngIf="claim.DebatorPO">
            <span class="ClaimCardLabel">{{ 'Invoice' | translate }}:</span>
            <span class="ClaimCardValue">{{ claim.DebatorPO }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="ClaimLoadingState" *ngIf="loadingClaims">
      <i class="material-icons rotating">refresh</i>
      <span>{{ 'LoadingClaims' | translate }}</span>
    </div>

    <!-- Empty State -->
    <div class="ClaimEmptyState" *ngIf="!loadingClaims && claims.length === 0">
      <i class="material-icons">inbox</i>
      <span>{{ 'NoClaimsFound' | translate }}</span>
    </div>
  </div>

  <!-- VIEW CLAIM MODE -->
  <div *ngIf="viewMode && !showError">
    <!-- Back Button -->
    <div class="ClaimViewBackButton" (click)="backToClaimsList()">
      <i class="material-icons">arrow_back</i>
      <span>{{ 'BackToClaimsList' | translate }}</span>
    </div>

    <!-- Loading State -->
    <div class="ClaimLoadingState" *ngIf="loadingClaimDetails">
      <i class="material-icons rotating">refresh</i>
      <span>{{ 'LoadingClaimDetails' | translate }}</span>
    </div>

    <!-- Claim Details (Read-Only) -->
    <div class="ClaimViewContainer" *ngIf="!loadingClaimDetails && selectedClaim">
      <!-- Claim Header -->
      <div class="ClaimViewHeader">
        <div class="ClaimViewTitle">
          <i class="material-icons">report_problem</i>
          <span>{{ selectedClaim.Title }}</span>
        </div>
        <div class="ClaimViewReference">{{ selectedClaim.Reference }}</div>
      </div>

      <!-- Claim Info -->
      <div class="ClaimViewInfoSection">
        <div class="ClaimViewInfoRow">
          <span class="ClaimViewInfoLabel">{{ 'Date' | translate }}:</span>
          <span class="ClaimViewInfoValue">{{ selectedClaim.EventRegisterUI }}</span>
        </div>
        <div class="ClaimViewInfoRow">
          <span class="ClaimViewInfoLabel">{{ 'Status' | translate }}:</span>
          <span class="ClaimViewInfoValue">{{ selectedClaim.Status?.Name }}</span>
        </div>
        <div class="ClaimViewInfoRow" *ngIf="selectedClaim.GeneralType">
          <span class="ClaimViewInfoLabel">{{ 'ClaimType' | translate }}:</span>
          <span class="ClaimViewInfoValue">{{ selectedClaim.GeneralType?.Name }}</span>
        </div>
        <div class="ClaimViewInfoRow" *ngIf="selectedClaim.DebatorPO">
          <span class="ClaimViewInfoLabel">{{ 'Invoice' | translate }}:</span>
          <span class="ClaimViewInfoValue">{{ selectedClaim.DebatorPO }}</span>
        </div>
      </div>

      <!-- Partner Agents Section -->
      <div class="ClaimViewAgentsSection">
        <div class="ClaimViewSectionTitle ClaimViewCollapsibleHeader" (click)="toggleViewAgentsSection()">
          <div class="ClaimViewSectionTitleLeft">
            <i class="material-icons">group</i>
            <span>{{ 'PartnerAgents' | translate }}</span>
            <span class="ClaimViewSectionCount" *ngIf="claimPartnerAgents?.length > 0">({{ claimPartnerAgents.length }})</span>
          </div>
          <i class="material-icons ClaimViewChevron" [class.ClaimViewChevronExpanded]="viewAgentsSectionExpanded">chevron_right</i>
        </div>

        <div *ngIf="viewAgentsSectionExpanded" [@slideDown]>
          <!-- Loading State -->
          <div class="ClaimAgentsLoading" *ngIf="loadingPartnerAgents">
            <i class="material-icons rotating">refresh</i>
            <span>{{ 'Loading' | translate }}...</span>
          </div>

          <!-- Agents List -->
          <div class="ClaimAgentsList" *ngIf="!loadingPartnerAgents && claimPartnerAgents?.length > 0">
            <div class="ClaimAgentItem"
                 *ngFor="let agent of claimPartnerAgents"
                 [class.ClaimAgentItemSelected]="agent.IsSelected"
                 [class.ClaimAgentItemToggling]="togglingAgentId === agent.ID"
                 (click)="toggleClaimPartnerAgent(agent)">
              <i class="material-icons ClaimAgentCheckIcon">{{ agent.IsSelected ? 'check_circle' : 'radio_button_unchecked' }}</i>
              <span class="ClaimAgentEmail">{{agent.Email}}<span class="ClaimAgentDepartment" *ngIf="agent.Department?.Name"> - {{agent.Department.Name}}</span></span>
              <i class="material-icons ClaimAgentSpinner rotating" *ngIf="togglingAgentId === agent.ID">refresh</i>
            </div>
          </div>

          <!-- No Agents Message -->
          <div class="ClaimNoAgents" *ngIf="!loadingPartnerAgents && (!claimPartnerAgents || claimPartnerAgents.length === 0)">
            <i class="material-icons">person_off</i>
            <span>{{ 'NoAgentsAvailable' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Claimed Products (Read-Only) -->
      <div class="ClaimViewProductsSection" *ngIf="viewClaimProducts && viewClaimProducts.length > 0">
        <div class="ClaimViewSectionTitle ClaimViewCollapsibleHeader" (click)="toggleViewProductsSection()">
          <div class="ClaimViewSectionTitleLeft">
            <i class="material-icons">inventory_2</i>
            <span>{{ 'ClaimedProducts' | translate }}</span>
            <span class="ClaimViewSectionCount">({{ viewClaimProducts.length }})</span>
          </div>
          <i class="material-icons ClaimViewChevron" [class.ClaimViewChevronExpanded]="viewProductsSectionExpanded">chevron_right</i>
        </div>
        <div class="ClaimViewProductsList" *ngIf="viewProductsSectionExpanded" [@slideDown]>
          <div class="ClaimViewProductCard" *ngFor="let product of viewClaimProducts">
            <div class="ClaimViewProductInfo">
              <div class="ClaimViewProductName">{{ product.Name }}</div>
              <div class="ClaimViewProductCode" *ngIf="product.Code">{{ product.Code }}</div>
              <div class="ClaimViewProductQty">
                <span>{{ 'ClaimedQty' | translate }}: <strong>{{ product.ClaimedQuantity }}</strong> / {{ product.DocQuantity }}</span>
              </div>
              <div class="ClaimViewProductClaimType" *ngIf="product.ClaimType">
                <span class="ClaimViewProductLabel">{{ 'ClaimType' | translate }}:</span>
                <span>{{ product.ClaimType.Name }}</span>
              </div>
              <div class="ClaimViewProductDescription" *ngIf="product.UserClaimDescription">
                <span class="ClaimViewProductLabel">{{ 'Description' | translate }}:</span>
                <span>{{ product.UserClaimDescription }}</span>
              </div>
              <div class="ClaimViewProductProofs" *ngIf="product.Proofs && product.Proofs.length > 0">
                <span class="ClaimViewProductLabel">{{ 'Proofs' | translate }}:</span>
                <div class="ClaimViewProofsList">
                  <div class="ClaimViewProofItem" *ngFor="let proof of product.Proofs; let i = index" (click)="downloadProof(proof, i)" title="Click to download">
                    <i class="material-icons">attach_file</i>
                    <span>{{ 'Proof' | translate }} {{ i + 1 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Comments Section (Interactive) -->
      <div class="ClaimViewCommentsSection">
        <div class="ClaimViewSectionTitle ClaimViewCollapsibleHeader" (click)="toggleViewCommentsSection()">
          <div class="ClaimViewSectionTitleLeft">
            <i class="material-icons">comment</i>
            <span>{{ 'ClaimComments' | translate }}</span>
            <span class="ClaimViewSectionCount" *ngIf="claimComments && claimComments.length > 0">({{ claimComments.length }})</span>
          </div>
          <i class="material-icons ClaimViewChevron" [class.ClaimViewChevronExpanded]="viewCommentsSectionExpanded">chevron_right</i>
        </div>

        <div *ngIf="viewCommentsSectionExpanded" [@slideDown]>
        <!-- Existing Comments -->
        <div class="ClaimViewCommentsList" *ngIf="claimComments && claimComments.length > 0">
          <div class="ClaimViewCommentCard" *ngFor="let comment of claimComments">
            <div class="ClaimViewCommentText">{{ comment.Comment }}</div>
            <div class="ClaimViewCommentAuthor" *ngIf="comment.UserEmail">
              <i class="material-icons">person</i>
              <span>{{ comment.UserEmail }}</span>
            </div>
            <div class="ClaimViewCommentAttachment" *ngIf="comment.Base64UploadedDocument" (click)="downloadCommentAttachment(comment)" title="Click to download">
              <i class="material-icons">attach_file</i>
              <span>{{ 'Attachment' | translate }}</span>
            </div>

            <!-- Reply Button -->
            <div class="ClaimViewReplyButton" (click)="startReply(comment)">
              <i class="material-icons">reply</i>
              <span>{{ 'Reply' | translate }}</span>
            </div>

            <!-- Existing Replies -->
            <div class="ClaimViewRepliesList" *ngIf="comment.Replies && comment.Replies.length > 0">
              <div class="ClaimViewReplyCard" *ngFor="let reply of comment.Replies">
                <div class="ClaimViewReplyText">{{ reply.Reply }}</div>
                <div class="ClaimViewReplyAuthor" *ngIf="reply.UserEmail">
                  <i class="material-icons">person</i>
                  <span>{{ reply.UserEmail }}</span>
                </div>
                <div class="ClaimViewReplyAttachment" *ngIf="reply.Base64UploadedDocument" (click)="downloadReplyAttachment(reply)" title="Click to download">
                  <i class="material-icons">attach_file</i>
                  <span>{{ 'Attachment' | translate }}</span>
                </div>
              </div>
            </div>

            <!-- Reply Form (shown when replying to this comment) -->
            <div class="ClaimViewAddReplyForm" *ngIf="replyingToCommentID === comment.ID">
              <!-- Partner Agent Selector for Reply -->
              <div class="ClaimAgentSelectorWrapper ClaimAgentSelectorReply">
                <label class="ClaimAgentSelectorLabel">
                  <i class="material-icons">person</i>
                  <span>{{ 'ReplyAs' | translate }}</span>
                </label>
                <div class="CustomDropdownContainer AgentDropdownContainer">
                  <div class="CustomDropdownOverlay" *ngIf="replyAgentDropdownOpen" (click)="closeReplyAgentDropdown()"></div>
                  <div class="CustomDropdownBar AgentDropdownBar"
                       [class.disabled]="submittingReply || loadingPartnerAgents"
                       (click)="toggleReplyAgentDropdown()">
                    <i class="material-icons dropdown-icon-left">person</i>
                    <span class="CustomDropdownInput" [class.placeholder]="!selectedReplyAgent">
                      {{ selectedReplyAgent ? (selectedReplyAgent.Email + (selectedReplyAgent.Department?.Name ? ' - ' + selectedReplyAgent.Department.Name : '')) : ('SelectPartnerAgent' | translate) }}
                    </span>
                    <i class="material-icons dropdown-icon-clear" *ngIf="selectedReplyAgent" (click)="selectedReplyAgent = null; $event.stopPropagation()">close</i>
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults AgentDropdownResults" *ngIf="replyAgentDropdownOpen">
                    <div class="CustomDropdownResult" *ngFor="let agent of claimPartnerAgents" (click)="selectReplyAgent(agent)">
                      <div class="CustomDropdownResultMain">
                        <i class="material-icons" [style.color]="selectedReplyAgent?.ID === agent.ID ? '#4caf50' : '#86868b'">
                          {{ selectedReplyAgent?.ID === agent.ID ? 'check_circle' : 'radio_button_unchecked' }}
                        </i>
                        <span class="CustomDropdownResultText">{{ agent.Email }}<span class="AgentDropdownDepartment" *ngIf="agent.Department?.Name"> - {{ agent.Department.Name }}</span></span>
                      </div>
                    </div>
                    <div class="CustomDropdownResult CustomDropdownNoResults" *ngIf="!claimPartnerAgents || claimPartnerAgents.length === 0">
                      <span class="CustomDropdownResultText">{{ 'NoAgentsAvailable' | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <textarea
                class="ClaimViewReplyTextarea"
                [(ngModel)]="newReply"
                [placeholder]="'ReplyText' | translate"
                rows="3"
                [disabled]="submittingReply">
              </textarea>

              <!-- File Upload for Reply -->
              <div class="ClaimViewReplyFileUpload">
                <input
                  type="file"
                  #replyFileInput
                  (change)="onReplyFileSelected($event)"
                  style="display: none;"
                  [accept]="acceptedFileTypes">
                <button
                  class="ClaimViewAttachFileButton"
                  (click)="replyFileInput.click()"
                  [disabled]="submittingReply">
                  <i class="material-icons">attach_file</i>
                  <span>{{ 'AttachFile' | translate }}</span>
                </button>
                <div class="ClaimViewSelectedFile" *ngIf="newReplyFileName">
                  <i class="material-icons">description</i>
                  <span>{{ newReplyFileName }}</span>
                  <i class="material-icons ClaimViewRemoveFile" (click)="removeReplyFile()">close</i>
                </div>
              </div>

              <!-- Reply Action Buttons -->
              <div class="ClaimViewReplyActions">
                <button
                  class="ClaimViewSubmitReplyButton"
                  (click)="addReply()"
                  [disabled]="!newReply || submittingReply || !selectedReplyAgent">
                  <i class="material-icons" *ngIf="!submittingReply">send</i>
                  <span *ngIf="!submittingReply">{{ 'SubmitReply' | translate }}</span>
                  <span *ngIf="submittingReply">{{ 'Submitting' | translate }}...</span>
                </button>
                <button
                  class="ClaimViewCancelReplyButton"
                  (click)="cancelReply()"
                  [disabled]="submittingReply">
                  <span>{{ 'Cancel' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- No Comments Yet -->
        <div class="ClaimViewNoComments" *ngIf="!claimComments || claimComments.length === 0">
          <i class="material-icons">chat_bubble_outline</i>
          <span>{{ 'NoCommentsYet' | translate }}</span>
        </div>

        <!-- Add New Comment Form -->
        <div class="ClaimViewAddCommentForm">
          <div class="ClaimViewAddCommentTitle">{{ 'AddComment' | translate }}</div>

          <!-- Partner Agent Selector -->
          <div class="ClaimAgentSelectorWrapper">
            <label class="ClaimAgentSelectorLabel">
              <i class="material-icons">person</i>
              <span>{{ 'CommentAs' | translate }}</span>
            </label>
            <div class="CustomDropdownContainer AgentDropdownContainer">
              <div class="CustomDropdownOverlay" *ngIf="commentAgentDropdownOpen" (click)="closeCommentAgentDropdown()"></div>
              <div class="CustomDropdownBar AgentDropdownBar"
                   [class.disabled]="submittingComment || loadingPartnerAgents"
                   (click)="toggleCommentAgentDropdown()">
                <i class="material-icons dropdown-icon-left">person</i>
                <span class="CustomDropdownInput" [class.placeholder]="!selectedCommentAgent">
                  {{ selectedCommentAgent ? (selectedCommentAgent.Email + (selectedCommentAgent.Department?.Name ? ' - ' + selectedCommentAgent.Department.Name : '')) : ('SelectPartnerAgent' | translate) }}
                </span>
                <i class="material-icons dropdown-icon-clear" *ngIf="selectedCommentAgent" (click)="selectedCommentAgent = null; $event.stopPropagation()">close</i>
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults AgentDropdownResults" *ngIf="commentAgentDropdownOpen">
                <div class="CustomDropdownResult" *ngFor="let agent of claimPartnerAgents" (click)="selectCommentAgent(agent)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedCommentAgent?.ID === agent.ID ? '#4caf50' : '#86868b'">
                      {{ selectedCommentAgent?.ID === agent.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{ agent.Email }}<span class="AgentDropdownDepartment" *ngIf="agent.Department?.Name"> - {{ agent.Department.Name }}</span></span>
                  </div>
                </div>
                <div class="CustomDropdownResult CustomDropdownNoResults" *ngIf="!claimPartnerAgents || claimPartnerAgents.length === 0">
                  <span class="CustomDropdownResultText">{{ 'NoAgentsAvailable' | translate }}</span>
                </div>
              </div>
            </div>
          </div>

          <textarea
            class="ClaimViewCommentTextarea"
            [(ngModel)]="newComment"
            [placeholder]="'CommentText' | translate"
            rows="4"
            [disabled]="submittingComment">
          </textarea>

          <!-- File Upload -->
          <div class="ClaimViewCommentFileUpload">
            <input
              type="file"
              #commentFileInput
              (change)="onCommentFileSelected($event)"
              style="display: none;"
              [accept]="acceptedFileTypes">
            <button
              class="ClaimViewAttachFileButton"
              (click)="commentFileInput.click()"
              [disabled]="submittingComment">
              <i class="material-icons">attach_file</i>
              <span>{{ 'AttachFile' | translate }}</span>
            </button>
            <div class="ClaimViewSelectedFile" *ngIf="newCommentFileName">
              <i class="material-icons">description</i>
              <span>{{ newCommentFileName }}</span>
              <i class="material-icons ClaimViewRemoveFile" (click)="removeCommentFile()">close</i>
            </div>
          </div>

          <!-- Submit Button -->
          <button
            class="ClaimViewSubmitCommentButton"
            (click)="addComment()"
            [disabled]="submittingComment || !newComment.trim() || !selectedCommentAgent">
            <i class="material-icons" *ngIf="!submittingComment">send</i>
            <i class="material-icons rotating" *ngIf="submittingComment">refresh</i>
            <span>{{ submittingComment ? ('Submitting' | translate) : ('SubmitComment' | translate) }}</span>
          </button>
        </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NEW CLAIM TAB -->
  <div *ngIf="showNewClaimTab && !viewMode && !showError">

    <!-- Transparent Overlay (closes search results when clicking outside) -->
    <div class="SearchOverlayTransparent" *ngIf="showInvoiceResults" (click)="showInvoiceResults = false"></div>

    <!-- Page Header -->
    <div class="ClaimPageHeader">
      <div class="ClaimPageTitle">
        <span>{{ 'OpenNewClaim' | translate }}</span>
      </div>
      <div class="ClaimPageSubtitle">
        {{ 'ClaimDescription' | translate }}
      </div>
    </div>

  <!-- Success Message -->
  <div class="ClaimSuccessMessage" *ngIf="submitSuccess">
    <i class="material-icons">check_circle</i>
    <span>{{ 'ClaimSubmittedSuccessfully' | translate }}</span>
    <button class="ClaimNewButton" (click)="submitSuccess = false">
      <span>{{ 'OpenAnotherClaim' | translate }}</span>
    </button>
  </div>

  <!-- Claim Form -->
  <div class="ClaimFormContainer" *ngIf="!submitSuccess">

    <!-- Step 1: Search Invoice -->
    <div class="ClaimStepCard ClaimStepClickable" (click)="focusInvoiceSearch()">
      <div class="ClaimStepBadge">1</div>
      <div class="ClaimStepContent">
        <div class="ClaimStepHeader">
          <i class="material-icons ClaimStepIcon">search</i>
          <span class="ClaimStepTitle">{{ 'ClaimStep1Title' | translate }}</span>
        </div>
        <p class="ClaimStepDescription">{{ 'ClaimStep1Description' | translate }}</p>
      </div>
    </div>

    <!-- Invoice Search -->
    <div class="ClaimFormField">
      <label class="ClaimFieldLabel">
        <span>{{ 'SelectInvoice' | translate }} *</span>
      </label>
      <div class="ClaimSearchContainer">
        <div class="ClaimSearchBar" [class.highlighted]="invoiceSearchHighlighted">
          <i class="material-icons search-icon" *ngIf="!invoiceSearchTerm || invoiceSearchTerm.length === 0">search</i>
          <i class="material-icons clear-icon" *ngIf="invoiceSearchTerm?.length > 0" (click)="clearInvoiceSearch()">close</i>
          <input
            #invoiceSearchInput
            type="text"
            class="ClaimSearchInput"
            [placeholder]="'SearchInvoicePlaceholder' | translate"
            [(ngModel)]="invoiceSearchTerm"
            (focus)="onInvoiceSearchFocus()"
            (blur)="onInvoiceSearchBlur()"
            (ngModelChange)="invoiceSearchTermUpdate.next($event)"
          />
          <mat-spinner class="search-spinner" *ngIf="loadingInvoices" [diameter]="20"></mat-spinner>
        </div>

        <!-- Search Results Dropdown -->
        <div class="ClaimSearchResults" *ngIf="showInvoiceResults && searchedInvoices?.length > 0">
          <div class="ClaimSearchResult" *ngFor="let inv of searchedInvoices" (click)="selectInvoice(inv)">
            <div class="ClaimResultMain">
              <span class="ClaimResultBadge">{{ inv.AccountingNumber?.DisplayValue }}</span>
              <span class="ClaimResultDate">{{ inv.EventRegisterUIDate }}</span>
              <span class="ClaimResultTotal">{{ inv.Total?.UITotalQtyPriceVAT?.Integer }}{{ inv.Total?.UITotalQtyPriceVAT?.Decimals }} {{ inv.Currency?.Symbol || inv.Currency?.Name }}</span>
            </div>
          </div>
        </div>

        <!-- No Results -->
        <div class="ClaimSearchResults" *ngIf="showInvoiceResults && searchedInvoices?.length === 0 && !loadingInvoices">
          <div class="ClaimNoResults">
            <i class="material-icons">search_off</i>
            <span>{{ 'NoInvoicesFound' | translate }}</span>
          </div>
        </div>

        <!-- Selected Invoice Display -->
        <div class="ClaimSelectedDisplay" *ngIf="selectedInvoice">
          <div class="ClaimSelectedInfo">
            <i class="material-icons ClaimSelectedCheckmark">check_circle</i>
            <span class="ClaimSelectedName">{{ selectedInvoice.AccountingNumber?.DisplayValue }}</span>
            <span class="ClaimSelectedSecondary">{{ selectedInvoice.EventRegisterUIDate }}</span>
            <span class="ClaimSelectedSecondary">{{ selectedInvoice.Total?.UITotalQtyPriceVAT?.Integer }}{{ selectedInvoice.Total?.UITotalQtyPriceVAT?.Decimals }} {{ selectedInvoice.Currency?.Symbol || selectedInvoice.Currency?.Name }}</span>
          </div>
          <i class="material-icons clear-selected-icon" (click)="clearInvoiceSearch()" title="Clear selection">close</i>
        </div>
      </div>
    </div>

    <!-- Step 2: Configure Products (appears after invoice is selected) -->
    <div class="ClaimStepCard" *ngIf="selectedInvoice && !loadingProducts">
      <div class="ClaimStepBadge">2</div>
      <div class="ClaimStepContent">
        <div class="ClaimStepHeader">
          <i class="material-icons ClaimStepIcon">tune</i>
          <span class="ClaimStepTitle">{{ 'ClaimStep2Title' | translate }}</span>
        </div>
        <p class="ClaimStepDescription">{{ 'ClaimStep2Description' | translate }}</p>
      </div>
    </div>

    <!-- Products Loading Spinner -->
    <div class="ClaimProductsLoading" *ngIf="loadingProducts">
      <mat-spinner [diameter]="24"></mat-spinner>
      <span>{{ 'LoadingProducts' | translate }}</span>
    </div>

    <!-- Invoice Products Table -->
    <div class="ClaimProductsSection" *ngIf="selectedInvoice && claimProducts?.length > 0 && !loadingProducts">
      <div class="ClaimProductsHeader" (click)="toggleProductsSection()">
        <i class="material-icons header-icon">inventory_2</i>
        <span>{{ 'InvoiceProducts' | translate }}</span>
        <span class="ClaimProductsCount">({{ claimProducts.length }})</span>
        <i class="material-icons chevron-icon" [class.expanded]="productsExpanded">expand_more</i>
      </div>

      <div class="ClaimProductsList" [class.collapsed]="!productsExpanded">
        <div class="ClaimProductCard" *ngFor="let product of claimProducts; let i = index">
          <!-- Product Info -->
          <div class="ClaimProductInfo">
            <div class="ClaimProductName">{{ product.Name }}</div>
            <div class="ClaimProductDetails">
              <span class="ClaimProductCode" *ngIf="product.Code">{{ product.Code }}</span>
            </div>
            <!-- Description Rows -->
            <div class="ClaimProductDescriptionRows" *ngIf="product.DescriptionRows && product.DescriptionRows.length > 0">
              <div class="ClaimProductDescRow" *ngFor="let row of product.DescriptionRows">
                {{ row }}
              </div>
            </div>
            <div class="ClaimProductQty">
              <span>{{ 'InvoicedQty' | translate }}: <strong>{{ product.DocQuantity }}</strong></span>
            </div>
          </div>

          <!-- Product Controls -->
          <div class="ClaimProductControls">
            <!-- Claimed Quantity -->
            <div class="ClaimProductControl">
              <label class="ClaimProductControlLabel">{{ 'ClaimedQty' | translate }}</label>
              <div class="ClaimQtyInputWrapper">
                <button
                  type="button"
                  class="ClaimQtyBtn ClaimQtyBtnMinus"
                  (click)="decrementQuantity(product)"
                  [disabled]="product.ClaimedQuantity <= 0"
                >
                  <i class="material-icons">remove</i>
                </button>
                <input
                  type="text"
                  class="ClaimQtyInput"
                  [(ngModel)]="product.ClaimedQuantity"
                  (blur)="validateClaimedQuantity(product)"
                  (keypress)="onQuantityKeyPress($event)"
                  (paste)="onQuantityPaste($event)"
                  maxlength="4"
                />
                <button
                  type="button"
                  class="ClaimQtyBtn ClaimQtyBtnPlus"
                  (click)="incrementQuantity(product)"
                  [disabled]="product.ClaimedQuantity >= product.DocQuantity"
                >
                  <i class="material-icons">add</i>
                </button>
                <span class="ClaimQtyMax" *ngIf="product.ClaimType?.ID !== 3">/ {{ product.DocQuantity }}</span>
              </div>
            </div>

            <!-- Claim Type Dropdown -->
            <div class="ClaimProductControl ClaimTypeDropdownControl">
              <label class="ClaimProductControlLabel">{{ 'ClaimType' | translate }} *</label>
              <div class="CustomDropdownContainer">
                <div class="CustomDropdownOverlay" *ngIf="openClaimTypeDropdownIndex === i" (click)="closeClaimTypeDropdown()"></div>
                <div class="CustomDropdownBar" (click)="toggleClaimTypeDropdown(i)">
                  <i class="material-icons dropdown-icon-left">report_problem</i>
                  <span class="CustomDropdownInput" [class.placeholder]="!product.ClaimType">
                    {{ product.ClaimType?.Name || ('SelectClaimType' | translate) }}
                  </span>
                  <i class="material-icons dropdown-icon-clear" *ngIf="product.ClaimType" (click)="clearClaimType(product, $event)">close</i>
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="openClaimTypeDropdownIndex === i">
                  <div class="CustomDropdownResult" *ngFor="let type of productClaimTypes" (click)="selectClaimType(product, type)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="product.ClaimType?.ID === type.ID ? '#4caf50' : '#86868b'">
                        {{ product.ClaimType?.ID === type.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ type.Name }}</span>
                    </div>
                  </div>
                </div>

                <!-- Selected Claim Type Description (moved inside container) -->
                <div class="ClaimTypeDescription" *ngIf="product.ClaimType && product.ClaimType.Description">
                  <i class="material-icons">info</i>
                  <span>{{ product.ClaimType.Description }}</span>
                </div>
              </div>
            </div>

            <!-- User Claim Description Textarea -->
            <div class="ClaimProductControl ClaimProductDescriptionControl" *ngIf="product.ClaimType">
              <label class="ClaimProductControlLabel">{{ 'YourDescription' | translate }}</label>
              <div class="ClaimTextareaBar">
                <i class="material-icons input-icon">description</i>
                <textarea
                  class="ClaimTextarea"
                  [placeholder]="'DescribeTheProblem' | translate"
                  [(ngModel)]="product.UserClaimDescription"
                  maxlength="500"
                  rows="3"
                ></textarea>
              </div>
            </div>

            <!-- File Upload for Proof -->
            <div class="ClaimProductControl ClaimProductProofControl" *ngIf="product.ClaimType">
              <label class="ClaimProductControlLabel">{{ 'UploadProof' | translate }}</label>
              <div class="ClaimProductProofUpload">
                <label class="ClaimProofUploadBtn">
                  <i class="material-icons">add_photo_alternate</i>
                  <span>{{ 'AddProof' | translate }}</span>
                  <input
                    type="file"
                    class="ClaimProofFileInput"
                    [accept]="acceptedFileTypes"
                    (change)="onProductFileSelected($event, product)"
                  />
                </label>
              </div>
              <!-- Uploaded Proofs List -->
              <div class="ClaimProductProofsList" *ngIf="product.Proofs?.length > 0">
                <div class="ClaimProductProofItem" *ngFor="let proof of product.Proofs; let pi = index">
                  <i class="material-icons proof-icon">insert_drive_file</i>
                  <span class="proof-name">{{ proof.FileName || ('Proof' | translate) + ' ' + (pi + 1) }}</span>
                  <i class="material-icons remove-proof-icon" (click)="removeProductProof(product, pi)">close</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Products Message -->
    <div class="ClaimNoProducts" *ngIf="selectedInvoice && claimProducts?.length === 0 && !loadingProducts">
      <i class="material-icons">inventory</i>
      <span>{{ 'NoProductsFound' | translate }}</span>
    </div>

    <!-- Step 3: Add Claim Title (only when invoice is selected) -->
    <div class="ClaimStepCard" *ngIf="selectedInvoice">
      <div class="ClaimStepBadge">3</div>
      <div class="ClaimStepContent">
        <div class="ClaimStepHeader">
          <i class="material-icons ClaimStepIcon">edit_note</i>
          <span class="ClaimStepTitle">{{ 'ClaimStep3Title' | translate }}</span>
        </div>
        <p class="ClaimStepDescription">{{ 'ClaimStep3Description' | translate }}</p>
      </div>
    </div>

    <!-- Claim Title (only when invoice is selected) -->
    <div class="ClaimFormField" *ngIf="selectedInvoice">
      <label class="ClaimFieldLabel">
        <span>{{ 'ClaimTitle' | translate }}</span>
      </label>
      <div class="ClaimInputBar">
        <i class="material-icons input-icon">title</i>
        <input
          type="text"
          class="ClaimTextInput"
          [placeholder]="'EnterClaimTitle' | translate"
          [(ngModel)]="claimTitle"
          maxlength="200"
        />
      </div>
    </div>

    <!-- Partner Agents Selection for New Claim (only when invoice is selected and products are loaded) -->
    <div class="ClaimViewAgentsSection NewClaimAgentsSection" *ngIf="selectedInvoice && Partner?.ID && !loadingProducts && claimProducts?.length > 0">
      <div class="ClaimViewSectionTitle ClaimViewCollapsibleHeader" (click)="toggleNewClaimAgentsSection()">
        <div class="ClaimViewSectionTitleLeft">
          <i class="material-icons">people</i>
          <span>{{ 'ClaimContactAgents' | translate }}</span>
          <span class="ClaimViewSectionCount" *ngIf="newClaimPartnerAgents.length > 0">({{ getNewClaimSelectedAgentsCount() }}/{{ newClaimPartnerAgents.length }})</span>
        </div>
        <i class="material-icons ClaimViewChevron" [class.ClaimViewChevronExpanded]="newClaimAgentsSectionExpanded">chevron_right</i>
      </div>

      <!-- Loading State -->
      <div class="ClaimLoadingState ClaimLoadingStateSmall" *ngIf="newClaimLoadingPartnerAgents && newClaimAgentsSectionExpanded" [@slideDown]>
        <i class="material-icons rotating">refresh</i>
        <span>{{ 'LoadingPartnerAgents' | translate }}</span>
      </div>

      <!-- Agents List -->
      <div class="EditAgentsList" *ngIf="!newClaimLoadingPartnerAgents && newClaimAgentsSectionExpanded && newClaimPartnerAgents.length > 0" [@slideDown]>
        <div class="EditAgentItem" *ngFor="let agent of newClaimPartnerAgents"
             [ngClass]="{ 'AgentSelected': agent.IsSelected == true }"
             (click)="toggleNewClaimPartnerAgent(agent)">
          <span class="AgentEmail">{{agent.Email}}<span class="AgentDepartment" *ngIf="agent.Department?.Name"> - {{agent.Department.Name}}</span></span>
          <i class="material-icons AgentIcon" *ngIf="agent.IsSelected == true">check_circle</i>
          <i class="material-icons AgentIcon" *ngIf="agent.IsSelected != true">radio_button_unchecked</i>
        </div>
      </div>

      <!-- No Agents Message -->
      <div class="ClaimNoAgentsMessage" *ngIf="!newClaimLoadingPartnerAgents && newClaimAgentsSectionExpanded && newClaimPartnerAgents.length === 0" [@slideDown]>
        <i class="material-icons">info</i>
        <span>{{ 'NoPartnerAgentsAvailable' | translate }}</span>
      </div>
    </div>

    <!-- Submit Button (only when invoice is selected) -->
    <div class="ClaimFormActions" *ngIf="selectedInvoice">
      <!-- Validation Message (when submit is disabled) -->
      <div class="ClaimValidationMessage" *ngIf="!isFormValid() && !submitting">
        <i class="material-icons">info</i>
        <span>{{ 'ClaimValidationMessage' | translate }}</span>
      </div>

      <!-- Product Validation Error Message -->
      <div class="ClaimProductValidationError" *ngIf="showProductValidationErrors && productValidationErrors.length > 0">
        <div class="ClaimProductValidationErrorHeader">
          <i class="material-icons">error</i>
          <span>{{ 'ClaimProductValidationError' | translate }}</span>
          <button class="ClaimProductValidationErrorClose" (click)="dismissProductValidationErrors()">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="ClaimProductValidationErrorContent">
          <div class="ClaimProductValidationErrorTableTitle">{{ 'ClaimProductsWithIssues' | translate }}</div>
          <div class="ClaimProductValidationErrorTable">
            <div class="ClaimProductValidationErrorTableHeader">
              <div class="ClaimProductValidationErrorTableHeaderCell">{{ 'Product' | translate }}</div>
              <div class="ClaimProductValidationErrorTableHeaderCell">{{ 'MissingFields' | translate }}</div>
            </div>
            <div class="ClaimProductValidationErrorTableRow" *ngFor="let error of productValidationErrors">
              <div class="ClaimProductValidationErrorTableCell">
                <div class="ClaimProductValidationErrorProductName">{{ error.product.Name }}</div>
                <div class="ClaimProductValidationErrorProductCode">{{ error.product.Code }}</div>
              </div>
              <div class="ClaimProductValidationErrorTableCell">
                <div class="ClaimProductValidationErrorMissingField" *ngIf="error.missingClaimType">
                  <i class="material-icons">radio_button_unchecked</i>
                  <span>{{ 'ClaimProductMissingClaimType' | translate }}</span>
                </div>
                <div class="ClaimProductValidationErrorMissingField" *ngIf="error.missingDescription">
                  <i class="material-icons">radio_button_unchecked</i>
                  <span>{{ 'ClaimProductMissingDescription' | translate }}</span>
                </div>
                <div class="ClaimProductValidationErrorMissingField" *ngIf="error.missingProof">
                  <i class="material-icons">radio_button_unchecked</i>
                  <span>{{ 'ClaimProductMissingProof' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        class="ClaimSubmitButton"
        [disabled]="!isFormValid() || submitting"
        (click)="submitClaim()"
      >
        <mat-spinner *ngIf="submitting" [diameter]="20" style="margin-right: 8px;"></mat-spinner>
        <i class="material-icons" *ngIf="!submitting">send</i>
        <span>{{ submitting ? ('Submitting' | translate) : ('SubmitClaim' | translate) }}</span>
      </button>
    </div>

    <!-- Error Message -->
    <div class="ClaimErrorMessage" *ngIf="submitError">
      <i class="material-icons">error</i>
      <span>{{ submitError }}</span>
    </div>

  </div>

  </div>
  <!-- End NEW CLAIM TAB -->

</div>
